export enum DisputeStatus {
  Open = 0,
  Submitted = 1,
  Paid = 2,
  Rejected = 3,
  Cancelled = 4,
  Expired = 5,
  Prepared = 6
}

export const DisputeStatusMapping: Record<DisputeStatus, string> = {
  [DisputeStatus.Open]: 'Open',
  [DisputeStatus.Submitted]: 'Submitted',
  [DisputeStatus.Paid]: 'Paid',
  [DisputeStatus.Rejected]: 'Rejected',
  [DisputeStatus.Cancelled]: 'Cancelled',
  [DisputeStatus.Expired]: 'Expired',
  [DisputeStatus.Prepared]: 'Prepared'
};
